module.exports = __webpack_public_path__ + "img/bg-step-line.48f0f24c.svg";